import fetch from '@/utils/fetch'

/**
 * 获取手机区号
 *
 * @export
 * @param {any} data
 * @returns
 */
export function getPhoneCode(data = {}) {
  return fetch({
    url: '/api_user/service/w/account/get_area_code',
    method: 'get',
    data
  })
}
/**
 * 获取图片验证码
 *
 * @export
 * @param {any} data
 * @returns
 */
export function getImageCode(sessionId) {
  return `${
    process.env.VUE_APP_BASE_API
  }/api_user/service/w/nwr/account/verifycode/image?sessionId=${sessionId}`
}

/**
 * 发送验证码
 *
 * @export
 * @param {any} data
 * @returns
 */
export function sendCode(data = {}) {
  return fetch({
    url: '/api_user/service/w/account/verifycode/send',
    method: 'post',
    data
  })
}

/**
 * 手机登录
 *
 * @export
 * @param {any} data
 * @returns
 */
export function phoneLogin(data = {}) {
  return fetch({
    url: '/api_user/service/w/account/phone_auto_register',
    method: 'post',
    data
  })
}

/**
 * 绑定手机号
 *
 * @export
 * @param {any} data
 * @returns
 */
export function bindPhone(data = {}) {
  return fetch({
    url: '/api_user/service/aw/mul/ow/account/bind_phone',
    // url: '/api_user/service/w/account/activity_register_without_check_user',
    method: 'post',
    data
  })
}

/**
 * 第三方登录
 *
 * @export
 * @param {any} data
 * @returns
 */
export function thirdLogin(data = {}) {
  return fetch({
    url: '/api_user/service/w/account/third_login',
    method: 'post',
    data
  })
}

/**
 * 第三方登录2，未注册的也会登录成功
 *
 * @export
 * @param {any} data
 * @returns
 */
export function thirdLogin2(data = {}) {
  return fetch({
    url: '/api_user/service/w/account/third_login_with_out_phone',
    method: 'post',
    data
  })
}
/**
 * 第三方注册
 *
 * @export
 * @param {any} data
 * @returns
 */
export function thirdRegister(data = {}) {
  return fetch({
    // url: '/api_user/service/w/account/activity_register',
    url: '/api_user/service/w/account/activity_register_without_check_user',
    method: 'post',
    data
  })
}

/**
 * 退出登录
 *
 * @export
 * @param {any} data
 * @returns
 */
export function logout(data = {}) {
  return fetch({
    url: '/api_user/service/aw/mul/ow/account/logout',
    method: 'post',
    data
  })
}
/**
 * 获取第三方用户OPEN_ID
 */
export function getThirdUser(data = {}) {
  return fetch({
    url: '/api_user/service/w/account/third_user',
    method: 'post',
    data
  })
}

/**
 * 获取无限制图片验证码
 */
export function getCode(data = {}) {
  return fetch({
    url: '/api_user/service/w/account/verifycode/image/nl',
    method: 'post',
    data
  })
}
